export const exportClearanceReportToPdf = async (data, filename, translations, statistics) => {
  try {
    if (!data || data.length === 0) {
      throw new Error('No data to export');
    }

    // Create print window
    const printWindow = window.open('', '_blank');
    
    if (!printWindow) {
      throw new Error('Please allow popups for this site');
    }

    const now = new Date();
    
    // Build HTML content
    const html = `
      <!DOCTYPE html>
      <html lang="ar" dir="rtl">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>${filename}</title>
        <style>
          @media print {
            @page {
              size: A4 landscape;
              margin: 10mm;
            }
            body {
              margin: 0;
              padding: 0;
            }
            .no-print {
              display: none !important;
            }
          }
          
          body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            direction: rtl;
            text-align: right;
            padding: 20px;
            background: white;
          }
          
          .header {
            text-align: center;
            margin-bottom: 20px;
            padding: 20px;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            border-radius: 10px;
          }
          
          .header h1 {
            margin: 0;
            font-size: 28px;
          }
          
          .info-section {
            margin-bottom: 20px;
            padding: 10px;
            background: #f8f9fa;
            border-right: 4px solid #667eea;
            border-radius: 5px;
            display: flex;
            justify-content: space-around;
          }
          
          .info-item {
            font-size: 13px;
          }
          
          .info-label {
            font-weight: bold;
            color: #495057;
          }
          
          .statistics-section {
            margin: 20px 0;
            padding: 15px;
            background: #e7f3ff;
            border-radius: 8px;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 15px;
          }
          
          .stat-box {
            padding: 10px;
            background: white;
            border-radius: 5px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          
          .stat-title {
            font-weight: bold;
            color: #667eea;
            margin-bottom: 8px;
            font-size: 14px;
          }
          
          .stat-item {
            padding: 5px;
            margin: 3px 0;
            background: #f8f9fa;
            border-radius: 3px;
            font-size: 12px;
          }
          
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 15px;
            font-size: 11px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          
          thead {
            background: #495057;
            color: white;
          }
          
          th {
            padding: 10px 5px;
            text-align: center;
            font-weight: bold;
            border: 1px solid #dee2e6;
          }
          
          td {
            padding: 8px 5px;
            text-align: center;
            border: 1px solid #dee2e6;
          }
          
          tbody tr:nth-child(even) {
            background: #f8f9fa;
          }
          
          .print-button {
            position: fixed;
            top: 20px;
            left: 20px;
            padding: 12px 24px;
            background: #667eea;
            color: white;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            font-size: 16px;
            font-weight: bold;
            box-shadow: 0 4px 6px rgba(0,0,0,0.1);
            z-index: 1000;
          }
          
          .print-button:hover {
            background: #5568d3;
          }
        </style>
      </head>
      <body>
        <button class="print-button no-print" onclick="window.print()">طباعة / حفظ كـ PDF</button>
        
        <div class="header">
          <h1>${filename}</h1>
        </div>
        
        <div class="info-section">
          <div class="info-item">
            <span class="info-label">${translations.generatedDate}:</span> ${now.toLocaleDateString('ar-SA')}
          </div>
          <div class="info-item">
            <span class="info-label">${translations.totalRecords}:</span> ${data.length}
          </div>
        </div>
        
        ${statistics ? `
          <div class="statistics-section">
            ${statistics.byLibrary ? `
              <div class="stat-box">
                <div class="stat-title">${translations.byLibrary}</div>
                ${Object.entries(statistics.byLibrary).map(([lib, count]) => `
                  <div class="stat-item">${lib}: ${count}</div>
                `).join('')}
              </div>
            ` : ''}
            
            ${statistics.byStaff ? `
              <div class="stat-box">
                <div class="stat-title">${translations.byStaff}</div>
                ${Object.entries(statistics.byStaff).map(([staff, count]) => `
                  <div class="stat-item">${staff}: ${count}</div>
                `).join('')}
              </div>
            ` : ''}
          </div>
        ` : ''}
        
        <table>
          <thead>
            <tr>
              <th>${translations.userName}</th>
              <th>${translations.barcode}</th>
              <th>${translations.patronGroup}</th>
              <th>${translations.clearanceDate}</th>
              <th>${translations.library}</th>
              <th>${translations.clearedBy}</th>
              <th>${translations.expirationDate}</th>
            </tr>
          </thead>
          <tbody>
            ${data.map(row => `
              <tr>
                <td>${row.userName}</td>
                <td>${row.barcode}</td>
                <td>${row.patronGroup}</td>
                <td>${row.clearanceDate}</td>
                <td>${row.library}</td>
                <td>${row.clearedBy}</td>
                <td>${row.expirationDate}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </body>
      </html>
    `;

    printWindow.document.write(html);
    printWindow.document.close();

    return { success: true, filename, recordCount: data.length };
  } catch (error) {
    console.error('PDF export error:', error);
    return { success: false, error: error.message };
  }
};
